import { useState, useEffect } from "react";
import { TermsStyled } from "./styles";
import ScrollTo from "../../utils/scrollTo";
import ApolloManualPDF from "../../assets/docs/apollo-user-manual.pdf";
import GestaoUnidadeImg from "../../assets/manual-apollo/gestao-unidade.png";
import ColaboradorImg from "../../assets/manual-apollo/colaborador.png";
import PacienteImg from "../../assets/manual-apollo/paciente.png";
import TotemImg from "../../assets/manual-apollo/totem.png";

export default function ApolloUserManual() {
  const [activeSection, setActiveSection] = useState("");
  const [expandedSections, setExpandedSections] = useState({});
  const [isMenuVisible, setIsMenuVisible] = useState(true);

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const toggleMenu = () => {
    setIsMenuVisible(!isMenuVisible);
  };

  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        "introducao",
        "primeiros-passos",
        "jornada-paciente",
        "gerenciamento-controle",
        "capacitacao-suporte",
        "informacoes-gerais",
      ];

      let currentSection = "";

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 150 && rect.bottom >= 150) {
            currentSection = section;
            break;
          }
        }
      }

      if (currentSection !== activeSection) {
        setActiveSection(currentSection);
        if (currentSection) {
          setExpandedSections((prev) => ({ ...prev, [currentSection]: true }));
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [activeSection]);

  return (
    <TermsStyled isMenuVisible={isMenuVisible}>
      <div className="container">
        {/* <button className="menu-toggle" onClick={toggleMenu}>
          {isMenuVisible ? "Fechar Menu" : "Abrir Menu"}
        </button> */}
        {isMenuVisible && (
          <div className="list" data-wow-delay=".6s">
            <ul className="menu">
              <li className="list-item">
                <a
                  onClick={() => ScrollTo("introducao")}
                  title="Introdução"
                  alt="Introdução"
                  className={activeSection === "introducao" ? "active" : ""}
                >
                  <strong>Introdução</strong>
                </a>
              </li>
              <li className="list-item">
                <a
                  onClick={() => {
                    ScrollTo("primeiros-passos");
                    toggleSection("primeiros-passos");
                  }}
                  title="1. Primeiros Passos"
                  alt="1. Primeiros Passos"
                  className={
                    activeSection === "primeiros-passos" ? "active" : ""
                  }
                >
                  <strong>1. Primeiros Passos</strong>
                </a>
              </li>
              <li className="list-item">
                <a
                  onClick={() => {
                    ScrollTo("jornada-paciente");
                    toggleSection("jornada-paciente");
                  }}
                  title="2. A Jornada do Paciente"
                  alt="2. A Jornada do Paciente"
                  className={
                    activeSection === "jornada-paciente" ? "active" : ""
                  }
                >
                  <strong>2. A Jornada do Paciente</strong>
                </a>
                {expandedSections["jornada-paciente"] && (
                  <>
                    <div className="sub-item">
                      <a onClick={() => ScrollTo("anamnese")}>2.1. Anamnese</a>
                    </div>
                    <div className="sub-item">
                      <a onClick={() => ScrollTo("ponto-remoto")}>
                        2.2. Ponto Remoto
                      </a>
                    </div>
                    <div className="sub-item">
                      <a onClick={() => ScrollTo("ponto-proximo")}>
                        2.3. Ponto Próximo
                      </a>
                    </div>
                    <div className="sub-item">
                      <a onClick={() => ScrollTo("astigmatismo")}>
                        2.4. Astigmatismo
                      </a>
                    </div>
                    <div className="sub-item">
                      <a onClick={() => ScrollTo("eixo")}>2.5. Eixo</a>
                    </div>
                    <div className="sub-item">
                      <a onClick={() => ScrollTo("finalizacao")}>
                        2.6. Finalização
                      </a>
                    </div>
                  </>
                )}
              </li>
              <li className="list-item">
                <a
                  onClick={() => {
                    ScrollTo("gerenciamento-controle");
                    toggleSection("gerenciamento-controle");
                  }}
                  title="3. Gerenciamento e Controle"
                  alt="3. Gerenciamento e Controle"
                  className={
                    activeSection === "gerenciamento-controle" ? "active" : ""
                  }
                >
                  <strong>3. Gerenciamento e Controle</strong>
                </a>
                {expandedSections["gerenciamento-controle"] && (
                  <>
                    <div className="sub-item">
                      <a onClick={() => ScrollTo("gestao-unidades")}>
                        3.1. Gestão de Unidades
                      </a>
                    </div>
                    <div className="sub-item">
                      <a onClick={() => ScrollTo("gestao-colaboradores")}>
                        3.2. Gestão de Colaboradores
                      </a>
                    </div>
                    <div className="sub-item">
                      <a onClick={() => ScrollTo("gestao-pacientes")}>
                        3.3. Gestão de Pacientes
                      </a>
                    </div>
                    <div className="sub-item">
                      <a onClick={() => ScrollTo("gestao-equipamentos")}>
                        3.4. Gestão de Equipamentos
                      </a>
                    </div>
                  </>
                )}
              </li>
              <li className="list-item">
                <a
                  onClick={() => {
                    ScrollTo("capacitacao-suporte");
                    toggleSection("capacitacao-suporte");
                  }}
                  title="4. Capacitação e Suporte"
                  alt="4. Capacitação e Suporte"
                  className={
                    activeSection === "capacitacao-suporte" ? "active" : ""
                  }
                >
                  <strong>4. Capacitação e Suporte</strong>
                </a>
                {expandedSections["capacitacao-suporte"] && (
                  <>
                    <div className="sub-item">
                      <a onClick={() => ScrollTo("treinamento-operadores")}>
                        4.1. Treinamento de Operadores
                      </a>
                    </div>
                    <div className="sub-item">
                      <a onClick={() => ScrollTo("estrutura-suporte")}>
                        4.2. Estrutura e Canais de Suporte
                      </a>
                    </div>
                  </>
                )}
              </li>
              <li className="list-item">
                <a
                  onClick={() => {
                    ScrollTo("informacoes-gerais");
                    toggleSection("informacoes-gerais");
                  }}
                  title="5. Informações Gerais"
                  alt="5. Informações Gerais"
                  className={
                    activeSection === "informacoes-gerais" ? "active" : ""
                  }
                >
                  <strong>5. Informações Gerais</strong>
                </a>
                {expandedSections["informacoes-gerais"] && (
                  <>
                    <div className="sub-item">
                      <a onClick={() => ScrollTo("estados-mensagens")}>
                        5.1. Estados e Mensagens
                      </a>
                    </div>
                    <div className="sub-item">
                      <a onClick={() => ScrollTo("mensagens-erro")}>
                        5.2. Mensagens de Erro
                      </a>
                    </div>
                    <div className="sub-item">
                      <a onClick={() => ScrollTo("atualizacoes-software")}>
                        5.3. Atualizações de Software
                      </a>
                    </div>
                  </>
                )}
              </li>
              <div className="color">
                <a
                  href={ApolloManualPDF}
                  download="Manual_Apollo.pdf"
                  className="download-button"
                >
                  Baixar Manual em PDF
                </a>
                <br />
                <span>Última atualização: 01 de dezembro de 2025</span>
              </div>
            </ul>
          </div>
        )}
        <div className="term" data-wow-delay=".7s">
          <h1>Manual do Usuário da Plataforma Apollo</h1>

          <h3 id="introducao">Introdução</h3>
          <p>
            A Plataforma Apollo é um software digital avançado, projetado para a
            realização de exames de visão de forma precisa e eficiente. O
            objetivo deste manual é servir como um guia completo para clientes e
            operadores, capacitando-os a utilizar todas as funcionalidades da
            plataforma com autonomia e segurança. Ao longo deste documento,
            abordaremos desde o processo de triagem de pacientes e o fluxo
            detalhado dos exames — Ponto Remoto, Ponto Próximo, Astigmatismo e
            Eixo — até a gestão completa de operações através do backoffice
            (Painel de Gestão).
          </p>

          <h3 className="spc" id="primeiros-passos">
            1. Primeiros Passos: Triagem e Critérios de Elegibilidade
          </h3>
          <p>
            A etapa de triagem é o primeiro e mais importante passo no fluxo da
            Plataforma Apollo. Este processo inicial foi estrategicamente
            desenhado para garantir a segurança do paciente e a precisão dos
            resultados, definindo com clareza quem está apto a realizar o exame
            segundo os parâmetros de elegibilidade atuais da plataforma.
          </p>
          <p>
            A tabela abaixo detalha os critérios de exclusão. Se um paciente
            atender a qualquer uma das condições de bloqueio, o exame não poderá
            prosseguir.
          </p>

          <table>
            <thead>
              <tr>
                <th>Categoria</th>
                <th>Condição de Bloqueio</th>
                <th>Regra de Triagem</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <strong>Idade (T1)</strong>
                </td>
                <td>O paciente não tem entre 18 e 40 anos.</td>
                <td>Resposta "Não" bloqueia o exame.</td>
              </tr>
              <tr>
                <td>
                  <strong>Uso Prévio (T2)</strong>
                </td>
                <td>O paciente usou lentes de contato nas últimas 24 horas.</td>
                <td>Resposta "Sim" bloqueia o exame.</td>
              </tr>
              <tr>
                <td>
                  <strong>Histórico Cirúrgico (T3)</strong>
                </td>
                <td>O paciente já realizou cirurgia nos olhos.</td>
                <td>Resposta "Sim" bloqueia o exame.</td>
              </tr>
              <tr>
                <td>
                  <strong>Condições Oculares (T4)</strong>
                </td>
                <td>
                  O paciente tem ambliopia ("olho preguiçoso"), visão monocular
                  (enxerga só de um olho) ou baixa visão diagnosticada.
                </td>
                <td>
                  Resposta "Sim" bloqueia o exame. Uma resposta "Não sei"
                  permite que o exame prossiga, mas sinaliza o cadastro para
                  revisão.
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Condições Sistêmicas (T5)</strong>
                </td>
                <td>A paciente está grávida ou amamentando.</td>
                <td>Resposta "Sim" bloqueia o exame.</td>
              </tr>
              <tr>
                <td>
                  <strong>Doenças Crônicas (T6)</strong>
                </td>
                <td>
                  O paciente tem diagnóstico de problemas neurológicos/lesão
                  cerebral, doenças da córnea, doenças da retina, glaucoma ou
                  diabetes.
                </td>
                <td>Selecionar qualquer uma das condições bloqueia o exame.</td>
              </tr>
              <tr>
                <td>
                  <strong>Grau Refrativo Elevado (T7)</strong>
                </td>
                <td>
                  O paciente foi informado que tem astigmatismo de mais de 3
                  graus.
                </td>
                <td>Resposta "Sim, mais de 3 graus" bloqueia o exame.</td>
              </tr>
              <tr>
                <td>
                  <strong>Grau Refrativo Elevado (T8)</strong>
                </td>
                <td>
                  O paciente foi informado que tem mais de 4 graus de miopia ou
                  hipermetropia.
                </td>
                <td>
                  Resposta "Sim" bloqueia o exame. Uma resposta "Não sei"
                  permite que o exame prossiga.
                </td>
              </tr>
            </tbody>
          </table>

          <p>
            Quando um critério de bloqueio é atendido, o sistema executa uma
            ação padrão: ele salva o cadastro do paciente, registra o motivo da
            exclusão e exibe uma Chamada para Ação (CTA) recomendando o
            encaminhamento para um médico oftalmologista.
          </p>
          <p>
            Para os pacientes considerados elegíveis após a triagem, o próximo
            passo da jornada é a Anamnese.
          </p>

          <h3 className="spc" id="jornada-paciente">
            2. A Jornada do Paciente: O Fluxo Detalhado do Exame
          </h3>
          <p>
            A jornada do paciente na Plataforma Apollo é uma sequência de etapas
            cuidadosamente desenhadas para coletar informações de saúde e
            avaliar a acuidade visual de forma precisa e padronizada. O fluxo
            guia o paciente desde as perguntas iniciais da Anamnese até a
            conclusão dos testes visuais, garantindo uma experiência autônoma e
            guiada.
          </p>
          <p>
            <strong>Importante:</strong> Todos os exames realizados na
            Plataforma Apollo são feitos duas vezes — primeiro no olho direito e
            depois no esquerdo — garantindo que cada etapa avalie
            individualmente ambos os olhos.
          </p>
          <p>
            <strong>Atenção, Operador:</strong> É fundamental garantir que o
            paciente realize todos os exames sem óculos ou lentes de contato
            para assegurar a precisão dos resultados.
          </p>

          <h4 id="anamnese">2.1. Anamnese</h4>
          <p>
            A Anamnese é a etapa de coleta de informações sobre a saúde geral e
            histórico ocular do paciente. Diferente da triagem, a maioria das
            respostas desta etapa não bloqueia o exame. Entretanto, alguns
            sinais clínicos críticos podem interromper imediatamente o fluxo,
            garantindo a segurança do paciente.
          </p>
          <p>A seguir, os blocos de perguntas que compõem a Anamnese:</p>
          <ul>
            <li>
              <strong>A1 – Daltonismo:</strong>
              <ul>
                <li>
                  <strong>Pergunta:</strong> "Você tem daltonismo (dificuldade
                  em diferenciar cores)?"
                </li>
                <li>
                  <strong>Tipo de Resposta:</strong> Sim / Não / Não sei.
                </li>
                <li>
                  <strong>Ação Resultante:</strong> Se a resposta for "Sim" ou
                  "Não sei", o sistema ativa uma interface de usuário (UI)
                  acessível, que utiliza símbolos/números somados a cores para
                  guiar o paciente.
                </li>
              </ul>
            </li>
            <li>
              <strong>A2 – Sintomas Atuais:</strong>
              <ul>
                <li>
                  <strong>Pergunta:</strong> "Você sente algum destes sinais
                  hoje?"
                </li>
                <li>
                  <strong>Tipo de Resposta:</strong> Múltipla escolha (Dor
                  ocular; Flashes de luz; Olho vermelho; Lacrimejamento
                  excessivo; Dor de cabeça; Perda súbita da visão; Nenhuma).
                </li>
                <li>
                  <strong>Ação Resultante:</strong> A seleção de "Perda súbita
                  da visão" gera um <strong>alerta crítico</strong> no sistema,
                  sinalizando a necessidade de um encaminhamento prioritário a
                  um especialista.
                </li>
              </ul>
            </li>
            <li>
              <strong>A3 – Cansaço Visual Prolongado:</strong>
              <ul>
                <li>
                  <strong>Pergunta:</strong> "Quando passa muito tempo lendo ou
                  trabalhando/estudando no computador, você costuma sentir
                  cansaço nas vistas ou dor de cabeça?"
                </li>
                <li>
                  <strong>Tipo de Resposta:</strong> Única escolha (Sim, com
                  muita frequência; Sim, com pouca frequência; Não costumo
                  sentir).
                </li>
                <li>
                  <strong>Ação Resultante:</strong> Esta resposta é um dos
                  fatores que determinam a necessidade do exame de Ponto
                  Próximo. O sistema pulará a etapa de Ponto Próximo se as três
                  seguintes condições forem atendidas: 1) a resposta aqui for
                  "Não costumo sentir" ou "Sim, com pouca frequência", 2) o
                  paciente obtiver um bom resultado no Ponto Remoto, e 3) o
                  paciente não apresentar queixas de visão de perto.
                </li>
              </ul>
            </li>
            <li>
              <strong>A4 – Correção:</strong>
              <ul>
                <li>
                  <strong>Pergunta:</strong> "Você usa óculos ou lentes de
                  contato?"
                </li>
                <li>
                  <strong>Tipo de Resposta:</strong> Múltipla escolha (Óculos;
                  Lentes).
                </li>
                <li>
                  <strong>Ação Resultante:</strong> A resposta é registrada para
                  indicar o uso de correção visual.
                </li>
              </ul>
            </li>
            <li>
              <strong>A5 – Medicamentos em Uso:</strong>
              <ul>
                <li>
                  <strong>Pergunta:</strong> "Quais medicamentos você utiliza
                  atualmente?"
                </li>
                <li>
                  <strong>Tipo de Resposta:</strong> Múltipla escolha.
                </li>
                <li>
                  <strong>Ação Resultante:</strong> A informação é registrada
                  para fornecer contexto clínico adicional. O sistema monitora
                  classes de medicamentos conhecidas por seus potenciais efeitos
                  na visão, incluindo:
                  <ul>
                    <li>Topiramato</li>
                    <li>Diuréticos Tiazídicos</li>
                    <li>Corticosteroides Sistêmicos</li>
                    <li>Anticolinérgicos</li>
                    <li>Inibidores da Colinesterase</li>
                    <li>Antidepressivos Tricíclicos (ADT)</li>
                    <li>
                      Inibidores Seletivos da Recaptação de Serotonina (ISRS)
                    </li>
                    <li>Cloroquina e Hidroxicloroquina</li>
                    <li>Amiodarona</li>
                    <li>Sildenafila e outros inibidores da PDE-5</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <strong>A6 – Histórico Familiar:</strong>
              <ul>
                <li>
                  <strong>Pergunta:</strong> "Algum familiar próximo já foi
                  diagnosticado com alguma destas condições?"
                </li>
                <li>
                  <strong>Tipo de Resposta:</strong> Múltipla escolha (Doenças
                  da córnea; Doenças da retina; Glaucoma; Nenhuma).
                </li>
                <li>
                  <strong>Ação Resultante:</strong> As respostas são registradas
                  como informação complementar.
                </li>
              </ul>
            </li>
            <li>
              <strong>Usa Colírio:</strong>
              <ul>
                <li>
                  <strong>Pergunta:</strong> "Usa colírio regularmente?"
                </li>
                <li>
                  <strong>Tipo de Resposta:</strong> Múltipla escolha (Para
                  lubrificar, Para pressão, não sei ou nenhuma das anteriores).
                </li>
                <li>
                  <strong>Ação Resultante:</strong> Se o paciente indicar o uso
                  "Para pressão", o sistema verifica se os exames de glaucoma
                  estão em dia, sugerindo agendamento com especialista caso
                  contrário.
                </li>
              </ul>
            </li>
          </ul>

          <h4 id="ponto-remoto">
            2.2. Ponto Remoto (Acuidade Visual à Distância)
          </h4>
          <p>
            O objetivo do exame de Ponto Remoto é avaliar a acuidade visual do
            paciente à distância. Durante o teste, o paciente deve identificar o
            número exato de figuras de maçã exibidas em uma tela. O exame começa
            com o paciente posicionado a uma distância padrão de 2,5 metros.
          </p>
          <p>
            <strong>Tentativas por Distância:</strong> O paciente tem até 5
            chances para responder corretamente em cada distância testada.
          </p>
          <p>
            <strong>Dispensa do Ponto Próximo:</strong> Se o paciente acertar 3
            ou mais das 5 tentativas nas distâncias de 2,5 metros ou 2 metros, o
            exame de Ponto Próximo é automaticamente dispensado, desde que as
            condições da anamnese também sejam atendidas.
          </p>
          <p>
            <strong>Aproximação Obrigatória:</strong> Caso o paciente não atinja
            o mínimo de acertos, o sistema o instruirá a se aproximar da tela.
            Se o acerto necessário ocorrer a uma distância inferior a 2 metros,
            a realização do exame de Ponto Próximo torna-se obrigatória.
          </p>

          <h4 id="ponto-proximo">2.3. Ponto Próximo (Condicional)</h4>
          <p>
            Este exame é condicional e só é realizado se o paciente não atingiu
            a acuidade visual esperada durante o teste de Ponto Remoto. Seu
            objetivo é avaliar o foco e a nitidez da visão a curtas distâncias.
          </p>
          <p>
            O processo funciona da seguinte forma: o sistema exibe um número na
            tela, e o paciente deve se aproximar até uma distância máxima de 40
            cm, respondendo "Sim" se consegue enxergar o número ou "Não" caso
            contrário. Se a resposta for "Sim", o sistema inicia a regra de
            percepção de borramento: ele pede ao paciente que se aproxime ainda
            mais e repete a pergunta "O número parece estar borrado?" por até 3
            vezes. Este processo iterativo de perguntar sobre o borramento
            permite ao sistema determinar o ponto focal mínimo do paciente com
            maior precisão.
          </p>

          <h4 id="astigmatismo">2.4. Astigmatismo</h4>
          <p>
            O objetivo deste exame é identificar distorções visuais e determinar
            a presença e a intensidade do astigmatismo. Para isso, o sistema
            utiliza uma imagem conhecida como mandala de astigmatismo.
          </p>
          <p>
            Durante o processo, o paciente deve observar a mandala e identificar
            a cor correspondente às linhas que mais se destacam, parecendo mais
            escuras, nítidas ou definidas que as outras.
          </p>
          <ul>
            <li>
              <strong>Distância Inicial:</strong> A distância para o teste
              varia. Se o Ponto Remoto foi bem-sucedido a 2m ou mais, o exame
              inicia a 1,5 metros. Caso contrário, inicia na mesma distância em
              que o Ponto Remoto foi concluído com sucesso.
            </li>
            <li>
              <strong>Dispensa do Exame de Eixo:</strong> Se o paciente
              responder "Nenhuma", indicando que nenhuma linha se destaca, o
              exame de Astigmatismo é finalizado e a etapa seguinte (Eixo) é
              dispensada.
            </li>
            <li>
              <strong>Processo de Refinamento:</strong> Se uma cor for
              selecionada, o sistema inicia um processo de confirmação chamado
              "melhor de três", onde o paciente realiza a tarefa mais vezes para
              refinar e confirmar o grau do astigmatismo.
            </li>
          </ul>
          <p>
            <strong>Nota para o Operador:</strong> Se um paciente relatar que vê
            múltiplas cores ou grupos de linhas se destacando, oriente-o a focar
            na cor que corresponde à linha ou grupo de linhas que parecem mais
            escuras e definidas em comparação com as demais.
          </p>

          <h4 id="eixo">2.5. Eixo (Condicional)</h4>
          <p>
            Este exame ocorre apenas se o astigmatismo for detectado na etapa
            anterior. Seu objetivo é definir a orientação angular (eixo) do
            astigmatismo, uma informação crucial para a prescrição de lentes
            corretivas.
          </p>
          <p>
            No processo, o sistema exibe um círculo preto na tela. O paciente
            deve se aproximar até conseguir visualizar três linhas brancas finas
            dentro do círculo. Assim que as linhas se tornarem visíveis, ele
            deve responder "Pronto" para que o sistema capture a medição.
          </p>

          <h4 id="finalizacao">2.6. Finalização do Exame</h4>
          <p>
            Ao concluir todas as etapas aplicáveis do fluxo de exames, o sistema
            exibe uma tela de finalização com a mensagem "Finalizado" e um botão
            de conclusão. Isso indica o término da jornada de testes para o
            paciente.
          </p>
          <p>
            Neste momento, é comum que o paciente pergunte: "E agora? O que
            acontece?". Como operador, sua função é fornecer clareza sobre os
            próximos passos. Informe ao paciente que o exame foi concluído com
            sucesso e que os resultados foram processados e enviados para o
            destino configurado (e-mail, portal do paciente, etc.). Explique os
            prazos esperados para o recebimento e oriente sobre os próximos
            passos, como aguardar o contato de um profissional ou acessar seu
            prontuário online.
          </p>
          <p>
            Com o exame finalizado, o operador pode utilizar as ferramentas de
            gestão disponíveis no backoffice para acompanhar o status e
            gerenciar as operações.
          </p>

          <h3 className="spc" id="gerenciamento-controle">
            3. Gerenciamento e Controle: Painel de Gestão
          </h3>
          <p>
            O Painel de Gestão, é a central de controle da Plataforma Apollo
            para o cliente. Esta ferramenta foi projetada para fornecer
            autonomia completa na gestão de unidades, colaboradores, pacientes e
            equipamentos, permitindo otimizar a operação diária de forma
            eficiente.
          </p>
          <p>
            O acesso ao painel é realizado por meio de um login básico. O
            sistema suporta diferentes níveis de permissão, que podem ser
            definidos no cadastro de usuários como Colaborador ou Administrador,
            garantindo que cada membro da equipe tenha acesso apenas às
            funcionalidades pertinentes à sua função.
          </p>

          <h4 id="gestao-unidades">3.1. Gestão de Unidades</h4>
          <p>
            Neste módulo, o operador gerencia todas as unidades operacionais
            para garantir a correta alocação de recursos e rastreamento de
            atividades. A partir deste painel, o operador pode executar as
            seguintes ações:
          </p>
          <ul>
            <li>
              Visualizar uma lista de unidades, com filtros para status (ativas
              ou inativas).
            </li>
            <li>
              Cadastrar novas unidades através de um formulário que solicita
              informações como nome e status inicial.
            </li>
            <li>Editar os dados de unidades existentes.</li>
            <li>
              Ativar ou inativar unidades conforme a necessidade operacional.
            </li>
          </ul>
          <img
            src={GestaoUnidadeImg}
            alt="Gestão de Unidades"
            className="manual-image"
          />

          <h4 id="gestao-colaboradores">3.2. Gestão de Colaboradores</h4>
          <p>
            O módulo de gestão de colaboradores é essencial para manter a equipe
            organizada e definir os níveis de acesso ao sistema. Um usuário com
            permissão de Administrador pode realizar as seguintes tarefas:
          </p>
          <ul>
            <li>
              Adicionar novos colaboradores preenchendo o formulário com os
              campos: <strong>Tipo de acesso</strong> (Administrador ou
              Colaborador), <strong>Nome</strong>, <strong>E-mail</strong>,{" "}
              <strong>CPF</strong> e <strong>Telefone</strong>.
            </li>
            <li>Editar os dados de usuários existentes.</li>
            <li>
              Gerenciar o status do usuário através do seletor "
              <strong>Colaborador ativo</strong>".
            </li>
            <li>
              Controlar o acesso ao painel de gestão com o seletor "
              <strong>Acesso ao painel</strong>".
            </li>
            <li>Vincular colaboradores a uma ou mais unidades operacionais.</li>
          </ul>
          <img
            src={ColaboradorImg}
            alt="Gestão de Colaboradores"
            className="manual-image"
          />

          <h4 id="gestao-pacientes">3.3. Gestão de Pacientes</h4>
          <p>
            Através deste módulo, o operador pode gerenciar os cadastros dos
            pacientes e o andamento de seus exames, garantindo um fluxo de
            atendimento organizado. As principais ações são:
          </p>
          <ul>
            <li>
              Cadastrar novos pacientes ou buscar na base de dados integrada.
            </li>
            <li>
              Visualizar o status dos exames (em andamento, concluído ou
              cancelado).
            </li>
            <li>
              Cancelar um exame em andamento, caso ocorra algum erro ou
              desistência do paciente.
            </li>
          </ul>
          <p>
            Além disso, é possível reenviar o laudo de um exame já concluído. O
            sistema permite o{" "}
            <strong>
              reenvio do laudo oficial diretamente para os dados de contato
              registrados do paciente
            </strong>
            .
          </p>
          <p>
            <strong>Aviso de Confidencialidade:</strong> Para garantir a
            privacidade do paciente e a confidencialidade dos dados de saúde, a
            visão do operador no painel de Gestão de Pacientes é restrita ao
            status do exame (ex: em andamento, concluído). Os resultados
            clínicos diretos não são acessíveis através desta interface. A única
            ação permitida relacionada ao resultado é acionar o reenvio do laudo
            oficial diretamente para os dados de contato registrados do
            paciente.
          </p>
          <img
            src={PacienteImg}
            alt="Gestão de Pacientes"
            className="manual-image"
          />

          <h4 id="gestao-equipamentos">3.4. Gestão de Equipamentos</h4>
          <p>
            Para assegurar que os exames sejam corretamente registrados e que o
            hardware seja rastreado, cada equipamento deve estar vinculado a uma
            unidade operacional. Este módulo centraliza o controle sobre o
            hardware utilizado. As funcionalidades disponíveis permitem ao
            operador:
          </p>
          <ul>
            <li>Vincular equipamentos a unidades específicas.</li>
            <li>Gerenciar o status de cada equipamento (ativo/inativo).</li>
            <li>
              Solicitar manutenção, especificando o tipo de problema (hardware,
              software ou dúvida).
            </li>
            <li>
              Desvincular equipamentos que não estão mais em uso em uma
              determinada unidade.
            </li>
          </ul>
          <p>
            Uma gestão eficiente da plataforma depende não apenas do uso correto
            dessas ferramentas, mas também de uma equipe bem preparada, o que
            nos leva à importância do treinamento e do suporte.
          </p>
          <img
            src={TotemImg}
            alt="Gestão de Equipamentos"
            className="manual-image"
          />

          <h3 className="spc" id="capacitacao-suporte">
            4. Capacitação e Suporte ao Operador
          </h3>
          <p>
            O sucesso da operação da Plataforma Apollo depende fundamentalmente
            de operadores bem treinados e de um sistema de suporte eficiente.
            Para garantir que os usuários maximizem o potencial da ferramenta e
            possam resolver quaisquer eventualidades, a Apollo oferece um
            programa completo de capacitação e canais de suporte estruturados.
            Esta seção detalha os recursos disponíveis para capacitar e auxiliar
            os operadores.
          </p>

          <h4 id="treinamento-operadores">4.1. Treinamento de Operadores</h4>
          <p>
            O programa de treinamento foi desenhado com um conceito central: o
            sistema deve ser auto eficiente para o paciente, enquanto o operador
            atua como um facilitador e suporte. O objetivo é dar ao operador a
            segurança necessária para orientar os pacientes sem interferir nos
            resultados.
          </p>
          <p>
            Os procedimentos de treinamento são divididos nas seguintes etapas:
          </p>

          <ol>
            <li>
              <strong>Treinamento Inicial:</strong> Conduzido pelo time de
              Customer Success (CS) antes do início da operação, este
              treinamento é baseado em vídeos oficiais e sessões práticas. Ele
              cobre toda a jornada do exame e o uso do backoffice, focando em
              como orientar o paciente e interpretar as mensagens do sistema.
            </li>
            <li>
              <strong>Treinamento Prático:</strong> Durante esta fase, o
              operador realiza simulações guiadas, vivenciando o fluxo completo
              do exame como se fosse o paciente. Essa experiência prática
              supervisionada proporciona uma compreensão profunda dos tutoriais
              e dos retornos automáticos da plataforma.
            </li>
            <li>
              <strong>Treinamentos e Atualizações:</strong> Sempre que a
              plataforma recebe uma atualização de software ou hardware, o
              cliente recebe uma documentação detalhada explicando as mudanças.
              Caso a atualização demande uma nova capacitação, um treinamento
              adicional é agendado com o time de CS.
            </li>
          </ol>
          <p>
            Os principais <strong>objetivos do treinamento</strong> são garantir
            a compreensão das instruções, padronizar os procedimentos
            operacionais e capacitar o operador a identificar e solucionar
            falhas comuns.
          </p>
          <h4 id="estrutura-suporte">4.2. Estrutura e Canais de Suporte</h4>
          <p>
            A Apollo oferece uma estrutura de suporte robusta, projetada para
            fornecer respostas rápidas e eficientes para diferentes tipos de
            necessidades.
          </p>
          <p>
            <strong>Frentes de Suporte:</strong>
          </p>
          <ul>
            <li>
              <strong>Time de Customer Success (CS) e Comercial:</strong>{" "}
              Responsável pelo primeiro nível de atendimento, auxiliando com
              dúvidas gerais, acompanhamento de performance e resolução de
              problemas simples.
            </li>
            <li>
              <strong>Canal de Suporte Integrado ao Painel de Gestão:</strong>{" "}
              Permite abrir chamados detalhados diretamente pela plataforma,
              acompanhando o status das solicitações em tempo real.
            </li>
            <li>
              <strong>Atendimento Técnico Especializado:</strong> Para casos
              complexos, como falhas de hardware ou erros críticos de sistema,
              que são encaminhados para a equipe técnica interna para
              diagnóstico aprofundado.
            </li>
          </ul>
          <p>
            <strong>Canais de Contato Oficiais:</strong>
          </p>
          <ul>
            <li>
              <strong>Plataforma de Chamados:</strong> Acesso direto pelo Painel
              de Gestão.
            </li>
            <li>
              <strong>E-mail de Suporte:</strong> Canal formal para registro de
              solicitações —{" "}
              <a href="mailto:atendimento@eyecarehealth.com.br">
                atendimento@eyecarehealth.com.br
              </a>
            </li>
            <li>
              <strong>Canal de Dúvidas:</strong> Disponível na interface do
              sistema para questões rápidas.
            </li>
          </ul>
          <p>
            <strong>Modelo de Escalonamento:</strong> O suporte opera em um
            modelo de três níveis para garantir que cada problema seja tratado
            pela equipe mais adequada:
          </p>
          <ul>
            <li>
              <strong>Nível 1 (CS):</strong> Trata de dúvidas operacionais e
              erros leves.
            </li>
            <li>
              <strong>Nível 2 (Suporte Técnico):</strong> Lida com falhas de
              software, bugs e comportamentos inesperados do sistema.
            </li>
            <li>
              <strong>Nível 3 (Engenharia):</strong> Responsável por ajustes
              estruturais, integração de hardware e correções críticas na
              plataforma.
            </li>
          </ul>
          <p>
            Com operadores bem treinados e um suporte acessível, é importante
            também conhecer as informações técnicas básicas do sistema para uma
            operação tranquila.
          </p>

          <h3 className="spc" id="informacoes-gerais">
            5. Informações Gerais do Sistema
          </h3>
          <p>
            Para garantir uma operação tranquila e a capacidade de identificar
            rapidamente situações comuns, é útil que o operador conheça as
            mensagens padrão do sistema, os erros mais frequentes e como as
            atualizações de software são gerenciadas. Este capítulo final
            fornece essas informações essenciais.
          </p>

          <h4 id="estados-mensagens">5.1. Estados e Mensagens do Sistema</h4>
          <p>
            Durante o uso da plataforma, o sistema exibirá diferentes mensagens
            de estado para informar sobre o processo em andamento. As principais
            são:
          </p>
          <ul>
            <li>
              <strong>Carregando:</strong> Indica que o sistema está preparando
              a próxima etapa do exame.
            </li>
            <li>
              <strong>Processando resultado:</strong> Exibido quando o software
              está analisando as respostas do paciente.
            </li>
            <li>
              <strong>Tentar novamente:</strong> Sinaliza que ocorreu uma
              inconsistência ou falha de detecção, e a etapa será repetida.
            </li>
            <li>
              <strong>Exame concluído:</strong> Confirma que todos os pontos do
              fluxo de exame foram finalizados com sucesso.
            </li>
            <li>
              <strong>Erro:</strong> Ocorre quando o fluxo do exame não pode
              continuar devido a uma falha.
            </li>
          </ul>

          <h4 id="mensagens-erro">5.2. Mensagens de Erro Básicas</h4>
          <p>
            Conhecer as mensagens de erro mais comuns ajuda o operador a
            identificar rapidamente a natureza de um problema. As três mensagens
            essenciais são:
          </p>
          <ul>
            <li>
              <strong>Falha de processamento:</strong> Ocorre quando o software
              não consegue interpretar os dados da etapa atual do exame.
            </li>
            <li>
              <strong>Fluxo interrompido:</strong> Indica que o exame foi
              encerrado antes de sua conclusão, seja por ação do usuário ou por
              uma falha.
            </li>
            <li>
              <strong>Conexão indisponível:</strong> Sinaliza que a conexão com
              a internet foi perdida, impossibilitando a continuação do exame ou
              o envio dos resultados ao backoffice.
            </li>
          </ul>

          <h4 id="atualizacoes-software">5.3. Atualizações de Software</h4>
          <p>
            A Plataforma Apollo é mantida em constante evolução para oferecer a
            melhor experiência e precisão. O processo de atualização funciona da
            seguinte forma:
          </p>
          <ul>
            <li>
              As atualizações de software são, em geral,{" "}
              <strong>automáticas</strong>.
            </li>
            <li>
              Durante o processo de atualização, o sistema pode ficar{" "}
              <strong>temporariamente indisponível</strong>.
            </li>
            <li>
              Recomenda-se sempre <strong>verificar a versão instalada</strong>{" "}
              no rodapé do Painel de Gestão para garantir que a unidade está
              operando com a build mais recente.
            </li>
          </ul>

          <h3 className="spc">Encerramento</h3>
          <p>
            Obrigado por utilizar a Plataforma Apollo. Nosso compromisso é
            apoiar sua operação, garantindo precisão nos exames, autonomia para
            sua equipe e uma jornada fluida para o paciente. Para sugestões de
            melhoria, dúvidas ou reportes de comportamento inesperado do
            sistema, entre em contato com nossos canais oficiais de suporte.
            Juntos, seguimos aprimorando a saúde visual de milhares de pessoas.
          </p>
        </div>
      </div>
    </TermsStyled>
  );
}
